// NRC (National Registration Card) parsing: 12/MaYaKa(N)123456 or ၁၂/မရက(နိုင်)၁၂၃၄၅၆
import { toAsciiDigits, toMyanmarDigits } from './digits';

export type NrcType = 'N' | 'E' | 'P' | 'T' | 'Y' | 'S';
export interface Nrc { region: number; township: string; type: NrcType; number: string }

const TYPE_MY: Record<NrcType, string> = { N: 'နိုင်', E: 'ဧည့်', P: 'ပြု', T: 'သာသနာ', Y: 'ယာယီ', S: 'စ' };
const TYPE_FROM_MY: Record<string, NrcType> = Object.fromEntries(Object.entries(TYPE_MY).map(([k, v]) => [v, k as NrcType]));

const RE = /^\s*([0-9]{1,2})\s*\/\s*([^\s()]+?)\s*\(\s*([^)]+?)\s*\)\s*([0-9]{6})\s*$/;

export function parseNrc(raw: string): Nrc | null {
  const m = RE.exec(toAsciiDigits(raw));
  if (!m) return null;
  const region = Number(m[1]);
  if (region < 1 || region > 14) return null;
  const t = m[3]!.toUpperCase();
  const type = (TYPE_FROM_MY[m[3]!] ?? (['N', 'E', 'P', 'T', 'Y', 'S'].includes(t) ? (t as NrcType) : null));
  if (!type) return null;
  return { region, township: m[2]!, type, number: m[4]! };
}

export function formatNrc(n: Nrc, lang: 'my' | 'en' = 'en'): string {
  if (lang === 'my') return `${toMyanmarDigits(n.region)}/${n.township}(${TYPE_MY[n.type]})${toMyanmarDigits(n.number)}`;
  return `${n.region}/${n.township}(${n.type})${n.number}`;
}

/** Canonical string for the blind index. */
export function canonicalNrc(n: Nrc): string {
  return `${n.region}/${n.township}(${n.type})${n.number}`;
}
